import styled from 'styled-components'

export const ArticleNavigation = styled.div`
    background: ${p => p.theme.bgColor};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 4px 8px 2px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`
